app.controller("ExamsManagerIndexController", [
    "$scope", "ExamsManagerService", "ProgramService", "$stateParams", "$state", "$uibModal", "ExamsService", "Subject", "StaticData", "ConfirmModal", "toastr",
    function ($scope, ExamsManagerService, ProgramService, $stateParams, $state, $uibModal, ExamsService, Subject, StaticData, ConfirmModal, toastr) {

        $scope.itemsPerPage = 100;
        $scope.totalItems = 0;


        $scope.program = $stateParams.program || null;
        $scope.student = $stateParams.student || null;
        $scope.status = $stateParams.status || null;
        $scope.day = $stateParams.day || null;
        $scope.session = $stateParams.session || null;
        // $scope.subject = $stateParams.subject || null;
        $scope.seat = $stateParams.seat || null;
        $scope.level = $stateParams.level || null;

        $scope.statuses = {
            approved: "ნებადართული",
            conditional: "წინაპირობით დაშვება",
            pending: "მომლოდინე",
            rejected: "უარყოფილი"
        };

        $scope.statusesList = [
            {status: "", text: "ყველა"},
            {status: "approved", text: "ნებადართული"},
            {status: "conditional", text: "წინაპირობით დაშვება"},
            {status: "pending", text: "მომლოდინე"},
            {status: "rejected", text: "უარყოფილი"}
        ];

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "ყველა"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        if ($stateParams.subject) {
            Subject.fetchOne($stateParams.subject).then(function (data) {
                $scope.subject = data.subject;
            });
        }

        $scope.details = function (examItem, $event) {
            // console.log(examItem);
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "ItemSelectionDetailsController",
                templateUrl: _pb + 'admin/exams/manager/item-selection-details.html',
                size: "md",
                resolve: {
                    examItem: function () {
                        return examItem;
                    }
                }
            }).result
                .then(function () {
                    $scope.loadPage($stateParams.page);
                });
        };

        $scope.loadPage = function (page, cb) {
            cb = cb || function () {
            };

            Promise.resolve()
                .then(function () {
                    if (!$stateParams.program) {
                        return Promise.resolve();
                    }
                    return ProgramService.fetchOne($stateParams.program).then(function (program) {
                        $scope.program = program;
                    });
                })
                .then(function () {
                    ExamsManagerService.fetchExamItems({
                        itemsPerPage: $scope.itemsPerPage,
                        page: page,
                        student: $scope.student,
                        subject: $stateParams.subject || null,
                        day: $scope.day || null,
                        session: $scope.session || null,
                        status: $scope.status || null,
                        program: $scope.program ? $scope.program._id : null,
                        seat: $scope.seat,
                        level: $scope.level
                    }).then(function (data) {
                        $scope.items = data.docs;
                        $scope.totalItems = data.total;
                        cb();
                    });
                });
        };

        $scope.loadPage($stateParams.page, function () {
            $scope.currentPage = parseInt($stateParams.page);
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
            // loadPage(page);
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return ExamsService.activationList({query: query}).then(function (data) {
                return data.docs.map(function(el) {
                    return el.subject;
                });
            });
        };

        $scope.getSessions = function () {
            return ExamsManagerService.fetchSessions().then(function (data) {
                $scope.sessions = data;
            });
        };

        function getDays () {
            return ExamsManagerService.fetchExamDays().then(function (data) {
                let examDays = data.map(a => {
                    return {
                        name:a.day.substr(0, 10),
                        id: a._id
                    }
                });
                examDays.unshift({name: 'ყველა', id: ''});
                $scope.examDays = examDays;
            });
        }
        getDays();

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs;
            });
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                student: $scope.student,
                program: $scope.program ? $scope.program._id : "",
                subject: $scope.subject ? $scope.subject._id : "",
                status: $scope.status,
                level: $scope.level,
                day: $scope.day,
            });
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "ExamsManagerAddItemController",
                templateUrl: _pb + 'admin/exams/manager/exams-manager-add-item.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {examItem: []};
                    }
                }
            }).result
                .then(function (result) {
                    $scope.loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.edit = function (item) {
            console.log("yea");
            $uibModal.open({
                controller: "ExamsManagerEditItemController",
                templateUrl: _pb + 'admin/exams/manager/exams-manager-edit-item.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {examItem: item};
                    }
                }
            }).result
                .then(function (result) {
                    $scope.loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.remove = function (examItem) {
            console.log(examItem);
            ConfirmModal.show({
                title: "გამოცდის წაშლა",
                message: "გსურთ საგნის სიიდან წაშლა?"
            }).result.then(function () {
                ExamsManagerService.removeExamItem({
                    examItemId: examItem._id
                }).then(function (result) {
                    toastr.success('', 'ჩანაწერი წარმატებით წაიშალა სიიდან');
                    $scope.loadPage($stateParams.page);
                });
            });
        };

        function getSelectedStudents () {
            return $scope.items.filter(function(student){return student.checked === true});
        }

        function removeSelections () {
            $scope.items.map(function(student){
                if (student.checked) {
                    student.checked = false;
                }
            });
        }

        $scope.openMultiEdit = function() {
            let selectedStudents = getSelectedStudents();
            $uibModal.open({
                controller: "ExamsManagerEditSelectedItemsController",
                templateUrl: _pb + 'admin/exams/manager/exams-manager-edit-selected-items.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            selectedStudents: selectedStudents,
                        };
                    }
                }}).result.then( function (params){
                    removeSelections();
                    toastr.success('ჩანაწერების რედაქტირება წარმატებით დასრულდა');
                    $scope.loadPage($stateParams.page);
            });

        }

        $scope.showMultiOperations = function () {
            if($scope.items){
                let selectedStudents = getSelectedStudents();
                let selectedStudentsCount = selectedStudents.length;

                return selectedStudentsCount > 0;
            }
        }

    }
]);
